module.exports = function() {
  return new Worker(__webpack_public_path__ + "c0be07f03cd4398fac85.worker.js");
};